/* eslint-disable import/no-cycle */
import { setSearchText, setCompanyName } from './actions';
import { ROOT_SLICE } from './constants';
import { selectThisSlice } from './selectors';

// ************
// PARTS
// ************
const reducerParts = {
	[setSearchText]: (state, { payload: { searchText } }) => {
		const slice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: { ...slice, searchText }
		};
	},

	[setCompanyName]: (state, { payload: { companyName } }) => {
		const slice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: { ...slice, companyName }
		};
	}
};

export default reducerParts;
